import React from 'react';
import PropTypes from 'prop-types';

const HelpTextSnippet = ({ field, isPost = false }) => {
  if (isPost) {
    switch (field) {
      default:
        return (<></>);
    }
  }

  switch (field) {
    case 'full_text':
      return (
        <div className="explanation-text" style={{ marginBottom: '0.5rem' }}>
          {/* commenting out until text formatting button works
          Be sure to clear all formatting before editing your text.
          You can do this by selecting all of your pasted copy and pressing the
          &nbsp;<b><u>T</u><sub>x</sub></b> button to the far right.
          */}
        </div>
      );
    case 'company_description':
      return (
        <div className="explanation-text" style={{ marginBottom: '0.5rem' }}>
          This &quot;about us&quot; section will appear below the body of your press release.
        </div>
      );
    case 'cloudinary_company_logo':
      return (
        <div className="explanation-text" style={{ marginBottom: '0.5rem' }}>
          PNG or JPEG under 500KB. Recommended image size is 250 x 250px.
        </div>
      );
    case 'cloudinary_header_image':
      return (
        <div className="explanation-text" style={{ marginBottom: '0.5rem' }}>
          PNG or JPEG under 1MB. Recommended image size is 1500 x 700px.
        </div>
      );
    case 'submitter_email':
      return (
        <div className="explanation-text" style={{ marginBottom: '0.5rem' }}>
          Enter a professional email address associated with your business domain.
        </div>
      );
    default:
      return (<></>);
  }
};

HelpTextSnippet.propTypes = {
  field: PropTypes.string.isRequired,
  isPost: PropTypes.bool,
};

export default HelpTextSnippet;
